<template>
  <div class="aframe-360-viewer">
    <v-dialog v-model="dialogEquipsVisible" persistent width="80%">
      <v-card>
        <v-card-title>
          <span class="headline">
            {{ getTranslation(
              'Selecione os',
              'Seleccione los')
            }} <span class="primary--text">
            {{ getTranslation(
              'materiais e equipamentos',
              'materiales y equipos')
            }}
            </span>
            {{ getTranslation(
              'necessários para execução desta prática',
              'necesarios para llevar a cabo esta práctica')
            }}
            </span>
        </v-card-title>
        <v-container class="px-8">
          <v-row class="text-center">
            <v-col v-for="(equipamento, index) in getFirstPracticeEquipments()" :key="`equipamento-${index}`" cols="6"
              sm="6" md="4" lg="3" class="pa-0">
              <v-card :key="index" class="d-inline-block mx-auto" style="min-height:210px" @click="teste(index)">
                <v-container>
                  <v-row justify="space-between">
                    <v-col cols="auto">
                      <v-img :src="'/img/equips/' + equipamento.imagem" />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="pt-0 pb-0 wrap">
                      <!-- <p>{{ selected }}</p> -->
                      <v-checkbox :key="'checkbox-${index}'" v-model="selected" :readonly="true" :value="index"
                        :label="equipamento.label" class="mt-0" hide-details />
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" text @click="handleEquipsAnswer()">
            {{ getTranslation(
              'Confirmar',
              'Confirmar')
            }}
            
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogAnswerVisible" persistent :width="cardWidth">
      <v-card>
        <v-card-title class="headline" :class="titleColour">
          {{ dialogAnswerTitle }}
        </v-card-title>
        <v-card-text>
          {{ dialogAnswerExplanation }}
        </v-card-text>
        <v-container v-if="dialogAnswerEquipsVisible === true" class="px-8">
          <v-row class="text-center">
            <v-col v-for="(equipamento, index) in getFirstPracticeEquipmentsNeeded()" :key="`equipamento-${index}`"
              cols="6" sm="6" md="4" lg="3" class="pa-0">
              <v-card :key="index" class="d-inline-block mx-auto" style="min-height:210px">
                <v-container>
                  <v-row justify="space-between">
                    <v-col cols="auto">
                      <v-img :src="'/img/equips/' + equipamento.imagem" />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="pt-0 pb-0 wrap">
                      {{ equipamento.label }}
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
        <v-card-actions class="">
          <v-btn class="mb-1 " block @click="$emit('selectComponent', 'CoreEtapa4'), $emit('nextStep', '4')">
            {{ getTranslation(
              'Ok',
              'Ok')
            }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Const from '@/helpers/const'
let json = require('../../json/pratica-' + Const.PRACTICE_NUMBER + '.json')
export default {
  data() {
    return {
      json: json,
      selected: [],
      dialogEquipsVisible: true,
      dialogAnswerVisible: false,
      dialogAnswerEquipsVisible: false,
      dialogAnswerTitle: null,
      dialogAnswerExplanation: null,
      titleColour: '',
      cardWidth: '0%'
    }
  },

  methods: {
    teste(index) {
      if (this.selected.includes(index)) {
        const filteredItems = this.selected.filter(item => item !== index)
        this.selected = filteredItems
      } else {
        this.selected.push(index)
      }
    },
    handleEquipsAnswer() {
      let answerIsCorrect = true
      let i = 0
      for (let equips of this.getFirstPracticeEquipments()) {
        // console.log('usuário selecionou: ' + this.selected.includes(i) + ' necessidade real é: ' + equips.necessidade)
        if (equips.necessidade === 'true') {
          if (!this.selected.includes(i)) {
            answerIsCorrect = false
            break
          }
        } else if (equips.necessidade === 'false') {
          if (this.selected.includes(i)) {
            answerIsCorrect = false
            break
          }
        }

        i = i + 1
      }

      if (answerIsCorrect) {
        this.dialogAnswerTitle = this.getTranslation('Perfeito!', '¡Perfecto!')
        this.dialogAnswerExplanation = this.getTranslation('Muito bem, você selecionou os equipamentos necessários.', 'Muy bien, has seleccionado los equipos necesarios.')
        this.titleColour = 'success--text'
        this.cardWidth = '30%'
      } else {
        this.dialogAnswerTitle = this.getTranslation('Hmmm, não. Na verdade...', 'Mmmm, no. En realidad...') 
        this.dialogAnswerExplanation = this.getTranslation('Os equipamentos e materiais necessários são os seguintes:', 'Los equipos y materiales necesarios son los siguientes:')
        this.dialogAnswerEquipsVisible = true
        this.titleColour = 'error--text'
        this.cardWidth = '80%'
      }
      this.toggleShowEquipsAnswer(true)
    },

    toggleShowEquipsAnswer(show) {
      if (show) {
        this.dialogEquipsVisible = false
        this.dialogAnswerVisible = true
      } else {
        this.dialogEquipsVisible = true
        this.dialogAnswerVisible = false
      }
    },

    getFirstPracticePresentation() {
      const pratica = this.json.pratica[0]
      return pratica.apresentacao
    },

    getFirstPracticeEquipments() {
      const pratica = this.json.pratica[0]
      return pratica.equipamentos
    },

    getFirstPracticeEquipmentsNeeded() {
      const pratica = this.json.pratica[0]

      var needed = pratica.equipamentos.filter(function (equip) {
        return equip.necessidade === 'true'
      })
      return needed
    },

    getTranslation(elementPortuguese, elementSpanish){
      if(Const.PRACTICE_NUMBER.includes('es')){
        return elementSpanish
      }
      return elementPortuguese
    },
  }
}
</script>

<style lang='scss' scoped>
.aframe-360-viewer {
  background-color: #ffffff;
  overflow: hidden;
  height: 100vh;
  width: 100vw;
}

.headline {
  word-break: break-word;

  @media all and (max-width: 768px) {
    font-size: 15px !important;
  }
}
</style>
